import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { defaultState as defaultViewState } from '../view/defaultState';
import { defaultState as defaultTabsState } from '../tabs/defaultState';
import { defaultState as defaultFlowState } from '../flow/defaultState';
import { defaultState as defaultLoginState } from '../login/defaultState';
import { defaultState as defaultAuthenticationState } from '../authentication/defaultState';
import { defaultState as defaultRegistrationState } from '../registration/defaultState';
import { defaultState as defaultSocialState } from '../social/defaultState';
import { defaultState as defaultPhoneAuthState } from '../phoneAuth/defaultState';
import { defaultState as defaultAgreementState } from '../agreement/defaultState';
export var defaultState = {
  view: defaultViewState,
  activeTab: defaultTabsState,
  activeFlow: defaultFlowState,
  login: defaultLoginState,
  phoneAuth: _objectSpread({}, defaultPhoneAuthState),
  authentication: _objectSpread({}, defaultAuthenticationState),
  registration: _objectSpread({}, defaultRegistrationState),
  social: _objectSpread({}, defaultSocialState),
  agreement: _objectSpread({}, defaultAgreementState),

  /* флаг isNextAgreementFlow добавлен в рамках эксперимента CD-116532 и будет уделён после его окончания */
  isNextAgreementFlow: false
};